<div class="bringoz-toggle-container">
    <input type="checkbox" autocomplete="off" class="btn-check" id="{{name}}"
           [checked]="checked" (change)="onChange($event)">
    <label class="btn btn-outline-primary" for="{{ name }}">{{ label }}</label>
</div>

